/* eslint-disable indent */
/* eslint-disable comma-dangle */
/* eslint-disable no-trailing-spaces */

type StaticImages = {
    readonly [fileName: string]: {
        uri?: string;
    };
}

const imageStaticSourcesByFileName: StaticImages = {
    '1twdFvamZ1tFkUEHDq6cm5.png': { uri: '/images/1twdFvamZ1tFkUEHDq6cm5.png' },
'9ntUGCRjD6jMEYfwYvkksD.png': { uri: '/images/9ntUGCRjD6jMEYfwYvkksD.png' },
'gaz95pusiB6j1FnHHULPyD.png': { uri: '/images/gaz95pusiB6j1FnHHULPyD.png' }
}

export default imageStaticSourcesByFileName
